import {Injectable} from '@angular/core';
import {ApiService, EnvironmentModel} from '@cas-hub/acabim-common-client';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {FullFile} from '../pages/financial/_models/financial-management.model';

@Injectable({
    providedIn: 'root'
})
export class FileUsageService extends ApiService {
    constructor(protected client: HttpClient,
                protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = 'file-usage';

    public uploadFile(buildingGUID: string, fileGUIDs: string[], type = 'building'): Observable<any> {
        return this.client.post(this.url(type + '/' + buildingGUID), fileGUIDs, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public getFilesFromObject(buildingGUID: string, type = 'building'): Observable<FullFile[]> {
        return this.client.get(this.url(type + '/' + buildingGUID), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => (data as any).data as FullFile[]));
    }

    public removeFiles(buildingGUID: string, fileGUIDs: string[], type = 'building'): Observable<any> {
        const option = {
            headers: this.defaultHeaders,
            body: fileGUIDs
        };
        return this.client.delete(this.url(type + '/' + buildingGUID), option);
    }

}
